import React from "react";

export const flagsExplanation = (
  <div>
    <p>Flags that will appear on variant pages:</p>
    <div className="tw-my-2">
      <ul>
        <li>
          <b>AC0:</b> The allele count is zero after filtering out
          low-confidence genotypes
        </li>
        <li>
          <b>AS-VQSR:</b> (gnomAD v3 only) Failed GATK Allele-Specific Variant
          Quality Recalibration (AS-VQSR)
        </li>
        <li>
          <b>InbreedingCoeff:</b> The Inbreeding Coefficient is less than 0.3
        </li>
        <li>
          <b>RF:</b> (gnomAD v2 only) Failed random forest filtering thresholds
          of 0.055 for exome SNVs, 0.206 for exome indels, 0.263 for genome
          SNVs, and 0.222 for genome indels
        </li>
      </ul>
    </div>
    <p>Flags that will appear in the variant table on gene/region pages:</p>
    <div className="tw-my-2">
      <ul>
        <li>
          <b>MNV:</b> Multinucleotide variant: the variant is found in phase
          with another variant, altering its functional interpretation
        </li>
        <li>
          <b>LCR:</b> Found in a low complexity region: these regions were
          identified with the symmetric DUST algorithm at a score threshold of
          30 and provided by Heng Li
        </li>
        <li>
          <b>LC pLoF:</b> Low-confidence pLoF, variant determined by LOFTEE to
          be likely not LoF for the transcript
        </li>
        <li>
          <b>pLoF Flag:</b> Flagged by LOFTEE, a warning provided by LOFTEE to
          use caution when interpreting the transcript or variant
        </li>
        <li>
          <b>NC Transcript:</b> Marked in a putative LoF category by VEP
          (essential splice, stop-gained, or frameshift) but appears on a
          non-protein-coding transcript
        </li>
      </ul>
    </div>
  </div>
);
